module.exports = __webpack_public_path__ + "media/metronic/_theme/media/products/product19-45b84d2b2c59d12717e706cae55e15ca.jpg";